<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M16.25 6.25H7.91667C6.99619 6.25 6.25 6.99619 6.25 7.91667V16.25C6.25 17.1705 6.99619 17.9167 7.91667 17.9167H16.25C17.1705 17.9167 17.9167 17.1705 17.9167 16.25V7.91667C17.9167 6.99619 17.1705 6.25 16.25 6.25Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.91667 12.9167C2 12.9167 1.25 12.1667 1.25 11.25V2.91667C1.25 2 2 1.25 2.91667 1.25H11.25C12.1667 1.25 12.9167 2 12.9167 2.91667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCopy',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
